import { render, staticRenderFns } from "./unreviewed.vue?vue&type=template&id=4aeeaa38&scoped=true&"
import script from "./unreviewed.vue?vue&type=script&lang=js&"
export * from "./unreviewed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeeaa38",
  null
  
)

export default component.exports